module.exports = __webpack_public_path__ + "static/media/Telecable-Regular.800a5438.ttf";